<section class="search" #searchContainer>
  <div class="search__input">
    <!-- TODO: dynamically toggle directive -->
    <input
      *ngIf="isNumberOnly"
      id="{{ id }}"
      class="form-control"
      [ngClass]="{ 'ng-invalid': wrongNationalIdFormat || hasDupclicatePartyError || hasLocallyDupclicatePartyError }"
      [formControl]="searchKeywords"
      minLength="{{ minLength }}"
      maxLength="{{ maxLength }}"
      (keyup.enter)="!disableSubmitButton && onSearchClick()"
      placeholder="{{ 'searchInputPlaceholder' | translate }}"
      autocomplete="off"
      appNumbersOnly
      required
    />
    <input
      *ngIf="!isNumberOnly"
      id="{{ id }}"
      class="form-control"
      [ngClass]="{ 'ng-invalid': hasDupclicatePartyError || hasLocallyDupclicatePartyError }"
      [formControl]="searchKeywords"
      minLength="{{ minLength }}"
      maxLength="{{ maxLength }}"
      (keyup.enter)="!disableSubmitButton && onSearchClick()"
      placeholder="{{ 'searchInputPlaceholder' | translate }}"
      autocomplete="off"
      required
    />
    <span *ngIf="wrongNationalIdFormat" class="invalid-feedback">{{ 'nationalIdInvalid' | translate }} </span>
    <span *ngIf="hasDupclicatePartyError && !hasLocallyDupclicatePartyError" class="invalid-feedback">{{
      'duplicatePartyError' | translate
    }}</span>
    <span *ngIf="hasLocallyDupclicatePartyError && !hasDupclicatePartyError" class="invalid-feedback">{{
      'duplicatePartyError' | translate
    }}</span>

    <div class="search__results" *ngIf="!isLoading && showDropdown">
      <div *ngFor="let result of searchResults" class="item" (click)="onSelect(result)">
        <ng-container *ngIf="showPersonTemplate && result.person">
          {{ result.id }}
          <ng-container *ngIf="result.person.firstName">
            {{ result.person.firstName }}
          </ng-container>
          <span class="not-found" *ngIf="!result.person.firstName">
            {{ 'firstNameNotFound' | translate }}
          </span>
          <span class="not-found" *ngIf="!result.person.firstName && !result.person.lastName">
            -
          </span>
          <ng-container *ngIf="result.person.lastName">
            {{ result.person.lastName }}
          </ng-container>
          <span class="not-found" *ngIf="!result.person.firstName">
            {{ 'lastNameNotFound' | translate }}
          </span>
        </ng-container>
        <ng-container *ngIf="!showPersonTemplate">
          {{ result.id }} {{ result.company?.companyName }}
          {{ result.company?.branch }}
        </ng-container>
      </div>
    </div>
    <div class="search__loading" *ngIf="isLoading">
      <div class="item">
        Loading...
      </div>
    </div>
  </div>

  <div class="search__button">
    <button id="search-btn" class="btn btn-app-primary" (click)="onSearchClick()" [disabled]="disableSubmitButton">
      {{ searchBtnText | translate }}
    </button>
  </div>
</section>
